import type { EClassRoomDisciplinesStatus } from '@/shared/api/generated';

/**
 * Mapeia cada valor de `EClassRoomDisciplinesStatus` para a chave i18n do seu
 * rótulo (namespace `classPlanning`). O enum é fixo e pequeno (4 valores), então
 * os rótulos são mapeados estaticamente em vez de consultar o endpoint de lookup
 * `shared/class-room-disciplines-status`.
 */
export const CLASS_PLANNING_STATUS_LABEL_KEY: Record<EClassRoomDisciplinesStatus, string> = {
  1: 'status.planned',
  2: 'status.finished',
  3: 'status.canceled',
  4: 'status.confirmed',
};

/** Todos os valores de status, na ordem exibida na legenda e na coluna Status. */
export const CLASS_PLANNING_STATUS_VALUES: readonly EClassRoomDisciplinesStatus[] = [1, 2, 3, 4];

/**
 * Cor da bolinha de status (coluna Status da tabela e legenda) — paleta exata do
 * legado (laranja/preto/cinza claro/verde sólidos). A `Tag` do ADS não tem uma
 * variante "preto sólido" entre seu enum de `status`, por isso usa-se classes
 * Tailwind diretas em vez do componente `Tag`.
 */
export const CLASS_PLANNING_STATUS_DOT_COLOR: Record<EClassRoomDisciplinesStatus, string> = {
  1: 'bg-base-warning-500', // Planejada — laranja
  2: 'bg-base-neutral-black', // Finalizada — preto
  3: 'bg-base-gray-300', // Cancelada — cinza claro/outline
  4: 'bg-base-success-500', // Confirmada — verde
};

/**
 * Classes de uma pill sólida por status (fundo + texto), usadas só pela legenda
 * (`ClassPlanningStatusLegend`) — mesma paleta de {@link CLASS_PLANNING_STATUS_DOT_COLOR}.
 */
export const CLASS_PLANNING_STATUS_PILL_CLASSES: Record<EClassRoomDisciplinesStatus, string> = {
  1: 'bg-base-warning-500 text-base-neutral-white',
  2: 'bg-base-neutral-black text-base-neutral-white',
  3: 'bg-base-gray-100 text-base-gray-600',
  4: 'bg-base-success-500 text-base-neutral-white',
};

/**
 * Cor fixa do indicador de presença de módulo (coluna Módulo) — não varia por
 * status; aparece só quando a aula está vinculada a um módulo.
 */
export const CLASS_PLANNING_MODULE_INDICATOR_COLOR = 'bg-base-success-500';
